import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {WhoWeArePage} from '../../modules/main/WhoWeArePage'

const WhoWeArePageWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.WHOWEAREPAGE'})}</PageTitle>
      <WhoWeArePage />
    </>
  )
}

export {WhoWeArePageWrapper}
